import axios from "axios";
import { buildGameLoggyTypeFromGameLobbyPayload, GameLobbyType } from "models/GameLobbyType";
import { getAuthToken } from "utils/auth_helpers";
import { BASE_URL } from "utils/constants";

export const getGameLobbies: () => Promise<GameLobbyType[]> = () => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.headers.get["Authorization"] = `Bearer ${getAuthToken()}`;

  return axios
    .get("/api/game-lobby/list")
    .then((res) => {
      return res.data as GameLobbyType[];
    })
    .catch((err) => {
      console.log("Failure");
      console.log(err);
      return [];
    });
};

export const getGameLobby: (id: string) => Promise<GameLobbyType> = (id) => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.headers.get["Authorization"] = `Bearer ${getAuthToken()}`;

  return axios
    .get(`/api/game-lobby/${id}`)
    .then((res) => {
      return buildGameLoggyTypeFromGameLobbyPayload(res.data as GameLobbyType);
    })
    .catch((err) => {
      console.log("Failure");
      console.log(err);
      return {} as GameLobbyType;
    });
};
